import React, { memo, useCallback } from 'react';
import styled from 'styled-components';
import { Play } from "lucide-react";
import LazyImage from '../LazyImage/LazyImage';

const GameOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(5px);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.2s ease;
`;

const GameCard = styled.div`
  min-width: 142px;
  height: 195px;
  border-radius: 8px;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: transform 0.2s ease;

  &:hover {
    ${GameOverlay} {
      opacity: 1;
    }
    transform: translateY(-5px);
  }

  @media (max-width: 768px) {
    min-width: 115px;
    height: 160px;
  }
`;

const PlayIconContainer = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PlayIcon = styled(Play)`
  color: #fff;
  font-size: 24px;
`;

const GameCardComponent = memo(({ 
  game, 
  index, 
  onGameClick, 
  onImageLoad,
  onImageError,
  ...props 
}) => {
  const handleClick = useCallback(() => {
    onGameClick?.(game);
  }, [game, onGameClick]);

  const handleImageLoad = useCallback(() => {
    onImageLoad?.(game.id);
  }, [game.id, onImageLoad]);

  const handleImageError = useCallback(() => {
    onImageError?.(game.id);
  }, [game.id, onImageError]);

  return (
    <GameCard onClick={handleClick} {...props}>
      <LazyImage
        src={game.game_icon}
        alt={game.game_name || `Game ${index}`}
        fallbackLabel={game.game_name}
        onLoad={handleImageLoad}
        onError={handleImageError}
        threshold={0.1}
        rootMargin="100px"
      />
      <GameOverlay>
        <PlayIconContainer>
          <PlayIcon />
        </PlayIconContainer>
      </GameOverlay>
    </GameCard>
  );
});

GameCardComponent.displayName = 'GameCard';

export default GameCardComponent;
